import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token') || '';
    const currentUser = localStorage.getItem('currentUser');
    const reportName = sessionStorage.getItem('reportName');
    const currentPath = window.location.pathname;

    const headerSettings: Record<string, string | string[]> = {};
    for (const key of request.headers.keys()) {
      headerSettings[key] = request.headers.getAll(key) ?? [];
    }
    if (!window.location.href.includes('tracking?key')) {
      if (token) {
        headerSettings['Authorization'] = 'Bearer ' + token;
      }
    }
    if (currentUser) {
      headerSettings['customInfo'] = currentPath + '/' + reportName;
    }
    if (this.router.url === '/forgot-password') {
      headerSettings['Content-Type'] = 'application/x-www-form-urlencoded';
    } else {
      headerSettings['Content-Type'] = 'application/json';
    }
    headerSettings['observe'] = 'response';

    const changedRequest = request.clone({
      headers: new HttpHeaders(headerSettings),
    });
    return next.handle(changedRequest);
  }
}
